/**
 * Signage aspect-fit from device settings: `videoFit` chooses how video/image
 * signage fills the screen. Absent/unknown values default to cover (fill).
 */

export const VIDEO_FIT_VALUES = ["cover", "contain"] as const;
export type VideoFit = (typeof VIDEO_FIT_VALUES)[number];

/** Allowlist read of settings.videoFit; anything else means cover. */
export function readVideoFit(settings: unknown): VideoFit {
  const raw = (settings as { videoFit?: unknown } | null | undefined)?.videoFit;
  return raw === "contain" ? "contain" : "cover";
}

/** Tailwind object-fit class for the signage media layers. */
export function videoFitClass(fit: VideoFit): "object-cover" | "object-contain" {
  return fit === "contain" ? "object-contain" : "object-cover";
}
